/**
 * Filter for rates
 * This will filter the rooms that are shown based on the filter that is passed into the query string
 */
angular.module('bookingApp')
    .filter('filterRates', filterRates);

function filterRates(){
    function filterRoomRates(input, ratesToFilter){
        if(!(ratesToFilter.length > 0)){
            return input;
        }
        var out = [];
        var count = 0;
        angular.forEach(input, function(room){
            angular.forEach(ratesToFilter, function(filteredRate){
                if(room.rate.id === parseInt(filteredRate)){
                    count++;
                    out.push(room);
                }
            });
        });
        return out;
    }
    return filterRoomRates;
}
